import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { CSSProperties } from 'react';
import { MiViewSpacing, MiViewColors } from 'miview-ui/miviewTheme';

export const boxStyle: SxProps<Theme> = {
  overflow: 'hidden',
  padding: MiViewSpacing.xxxxSmall,
  '@media (max-width: 1279px)': {
    flexDirection: 'row',
    minWidth: '100%',
    maxWidth: '100%',
  },
};

export const gridContainerStyle: SxProps<Theme> = {
  overflow: 'hidden',
};

export const gridStyle: SxProps<Theme> = {
  padding: MiViewSpacing.xxxSmall,
  '@media (max-width: 1279px)': {
    minWidth: '100%',
    maxWidth: '100%',
  },
};

export const paperStyle: CSSProperties = {
  color: MiViewColors.secondary,
  border: `1px solid ${MiViewColors.primary}`,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  maxHeight: '100vh',
};

export const screenStyle: CSSProperties = {
  margin: '0px',
  position: 'relative',
  top: 'auto',
  left: 'auto',
  width: 'auto',
  zIndex: 0,
};
